// extracted by mini-css-extract-plugin
export default {"section3":"section3_section3__5BEBm","image3":"section3_image3__DwZ+I"};